<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
import BootstrapMixin from './mixins/BootstrapMixin'
export default {
  mixins: [BootstrapMixin],
  data() {
    return {}
  }
}
</script>
